import { Provider } from '@angular/core';

import { IrpfUseCasesImpl } from '@app/domain/use-cases/ptrab/irpf/irpf.use-cases';
import { IRPF_USE_CASES } from '@app/domain/use-cases/ptrab/irpf/irpf.use-cases.contract';

export const irpfUseCasesProvider: Provider = {
  provide: IRPF_USE_CASES,
  useClass: IrpfUseCasesImpl
};
